import maxDim from '../maxDim.json';
import minDim from '../minDim.json';

export const convertDimensionsToMinMaxDimensions = dimensions => {
  const cvtDimensions = [];
  Object.keys(dimensions).forEach(dimension => {
    const value = dimensions[dimension];
    let description;
    let min = null;
    let max = null;
    if (dimension.includes('Min')) {
      description = dimension.replace(' Min', '');
      min = value;
    } else {
      description = dimension.replace(' Max', '');
      max = value;
    }
    let cvtDim = cvtDimensions.find(item => item.description === description);
    if (!cvtDim) {
      cvtDim = { description, min, max };
      cvtDimensions.push(cvtDim);
    } else if (min !== null) {
      cvtDim.min = min;
    } else if (max !== null) {
      cvtDim.max = max;
    }
  });
  return cvtDimensions;
}

export const convertMinMaxDimensionsToDimensions = minMaxDimensions => {
  const dimensions = {};
  minMaxDimensions.forEach(dim => {
    const description = dim.description;
    const max = dim.max;
    const min = dim.min;
    if (description.includes('Odmaxw')) {
      dimensions.Odmaxw = max || min;
      return;
    }
    for (let i = 0; i < minDim.length; i++) {
      const mm = Object.keys(minDim[i])[0];
      const f = min !== null && minDim[i][mm];
      const m = mm.replace('Min ', '').replace('Min', '');
      if (!m) {
        if (f) {
          dimensions[`${description} Min`] = min;
        }
        break;
      } else if (description.includes(m)) {
        if (f) {
          dimensions[description.replace(m, mm)] = min;
        }
        break;
      }
    }
    for (let i = 0; i < maxDim.length; i++) {
      const mm = Object.keys(maxDim[i])[0];
      const f = max !== null && maxDim[i][mm];
      const m = mm.replace('Max ', '').replace('Max', '');
      if (!m) {
        if (f) {
          dimensions[`${description} Max`] = max;
        }
        break;
      } else if (description.includes(m)) {
        if (f) {
          dimensions[description.replace(m, mm)] = max;
        }
        break;
      }
    }
  });
  return dimensions;
}




// WEBPACK FOOTER //
// ./src/config/convert/convertDimensions.js